<template>
  <v-container v-if="typology.selectable" fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-list>
          <h3>
            Potencial Degradador
            <create-degrading-potential-for-tax
              :typology-id="typology.id"
              v-on:create-degrading-potential-for-tax="create($event, 'degrading_potentials_for_tax')"/>
          </h3>

        </v-list>

        <v-data-table
          :headers="headers"
          v-if="typology !== undefined"
          :items="typology.degrading_potentials_for_tax"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">
              <v-icon> mdi-{{ props.item.old ? 'checkbox-marked' : 'checkbox-blank-outline' }}</v-icon>
            </td>
            <td class="text-xs-center">
              <v-layout row justify-center>
                <edit-degrading-potential-for-tax
                  :typology-id="typology.id"
                  @update="update($event, 'degrading_potentials_for_tax')"
                  :degrading-potential-for-tax="Object.assign({},props.item)"/>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-divider/>

    <v-layout>
      <v-flex xs12>
        <v-list>
          <h3>
            Porte
            <create-typology-size-for-tax
              :typology-id="typology.id"
              v-on:create-typology-size-for-tax="create($event, 'typology_sizes_for_tax')">
            </create-typology-size-for-tax>
          </h3>
        </v-list>
        <v-data-table
          :headers="headers"
          :items="typology.typology_sizes_for_tax"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">
              <v-icon> mdi-{{ props.item.old ? 'checkbox-marked' : 'checkbox-blank-outline' }}</v-icon>
            </td>
            <td class="text-xs-center">
              <v-layout row justify-center>
                <edit-typology-size-for-tax
                  :typology-id="typology.id"
                  @update="update($event, 'typology_sizes_for_tax')"
                  :typology-size-for-tax="Object.assign({},props.item)"
                />
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-list>
          <h3>Enquadramento</h3>
        </v-list>
        <table class="v-datatable v-table theme--light elevation-1" v-if="btz != {}">
          <thead>
          <tr>
            <th>Porte\Potencial Degradador</th>
            <th v-for="dp in typology.degrading_potentials_for_tax" v-bind:key="dp.id">
              {{dp.name}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(ts) in typology.typology_sizes_for_tax" v-bind:key="ts.id">
            <td class="text-xs-center">{{ts.name}}</td>
            <td v-for="(dp) in typology.degrading_potentials_for_tax"
                v-bind:key="dp.id" class="text-xs-center">
              <v-autocomplete
                :items="zones"
                v-model="btz[ts.id][dp.id]"
                item-text="name"
                item-value="id"
                @input="updateBusinessTableZone(ts, dp, $event)"
                return-object
                single-line></v-autocomplete>
            </td>
          </tr>
          </tbody>
        </table>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="1000">
        {{ snackbarText }}
        </v-snackbar>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import CreateDegradingPotentialForTax from '@/components/configurations/typology/show/tax/create_degrading_potential_for_tax/CreateDegradingPotentialForTax';
import EditDegradingPotentialForTax from '@/components/configurations/typology/show/tax/edit_degrading_potential_for_tax/EditDegradingPotentialForTax';

import CreateTypologySizeForTax from '@/components/configurations/typology/show/tax/create_typology_size_for_tax/CreateTypologySizeForTax';
import EditTypologySizeForTax from '@/components/configurations/typology/show/tax/edit_typology_size_for_tax/EditTypologySizeForTax';

import BusinessTableZonesService from '@/services/applications/configurations/BusinessTableZonesService';
import ZoneService from '@/services/applications/configurations/ZoneService';

export default {
  name: 'TaxComponent',
  props: ['typology'],
  components: {
    CreateDegradingPotentialForTax,
    EditDegradingPotentialForTax,
    CreateTypologySizeForTax,
    EditTypologySizeForTax,
  },
  beforeMount() {
    this.fillZones();
  },
  mounted() {
    ZoneService
      .fetchZones()
      .then((response) => {
        this.zones = response.data;
      });
  },
  data() {
    return {
      dialog: false,
      dialogEditTypologySize: false,
      snackbar: false,
      btz: {},
      zones: [],
      headers: [
        { text: 'ID', value: 'id', width: '200' },
        { text: 'Nome', value: 'name', align: 'center' },
        { text: 'Antigo', value: 'old', align: 'center', width: '200' },
        { text: 'Ações', value: 'actions', align: 'center', width: '200' }],
      snackbarColor: 'success',
      snackbarText: '',
      valid: false,
    };
  },
  methods: {
    create(event, property) {
      this.typology[property].push(event);
      this.fillZones();
    },
    update(event, property) {
      this.typology[property].forEach((item, index) => {
        if (item.id === event.id) {
          Object.assign(this.typology[property][index], event);
        }
      });
    },
    fillZones() {
      const vm = this;
      const tss = this.typology.typology_sizes_for_tax;
      const dps = this.typology.degrading_potentials_for_tax;

      tss.forEach((ts) => {
        vm.btz[ts.id] = {};
        dps.forEach((dp) => {
          vm.btz[ts.id][dp.id] = {};
        });
        ts.business_table_zones.forEach((btz) => {
          vm.btz[ts.id][btz.degrading_potential_for_tax.id] = btz.zone;
        });
      });
    },
    updateBusinessTableZone(typologySize, degradingPotential, zone) {
      const vm = this;
      vm.$store.dispatch('setLoadingDialog', true);
      BusinessTableZonesService
        .createOrUpdateBusinessTableZone(typologySize.id, degradingPotential.id, zone.id)
        .then(() => {
          vm.snackbarColor = 'success';
          vm.snackbarText = 'Enquadramento salvo com sucesso';
          vm.snackbar = true;
        })
        .catch(() => {
          vm.snackbarColor = 'error';
          vm.snackbarText = 'Erro ao salvar enquadramento';
          vm.snackbar = true;
        })
        .finally(() => {
          vm.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
